import { useState } from 'react';
import ExtensionTypeRequest from '../../../../../../Classes/ResponseModels/ApplicationManagement/ExtensionTypeRequest.js';
import { UpdateExtensionType } from '../../../../_api';
import styles from '../../../../ApplicationMaintenance.module.scss';
import ApiErrors from '../../../../components/NewApplication/ApiErrors';
import Modal from '@mui/material/Modal';
import Base from '../../../../../Base/Base';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import Spinner from '../../../../../../components/UI/Spinner/Spinner';
import classNames from 'classnames';
import Section from '../../../../components/NewApplication/Section';

// @app : AppManagementModel
// @currentUser : userProfile from useIdentify() hook
//reload : function
const ExtensionTypeUpdate = ({
	app,
	currentUser,
	reload,
	disabled,
	requirementNumber,
	extension,
}) => {
	const [localExtension, setLocalExtension] = useState(extension);
	const [modalOpen, setModalOpen] = useState(false);
	const [apiErrors, setApiErrors] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const handleChange = e => {
		setLocalExtension({
			...localExtension,
			[e.target.name]: e.target.value,
		});
	};

	const handleSave = () => {
		setIsLoading(true);
		let request = new ExtensionTypeRequest(
			app,
			currentUser,
			localExtension,
			requirementNumber
		);
		request.RequirementNumber = requirementNumber;
		UpdateExtensionType(request).then(response => {
			if (response?.App?.Errors.length > 0) {
				setApiErrors(response?.App?.Errors);
			} else {
				if (apiErrors.length === 0) {
					setModalOpen(false);
					//reload the extensions to reflect the changes to the extensions if no errors
					reload();
				}
			}
			setIsLoading(false);
		});
	};

	//resolve error message cause by null value on inputs
	const resolveTextAreaNull = value => {
		if (value === null) {
			return '';
		} else return value;
	};
	return (
		<div>
			<div className={styles.controlsContainer}>
				<Button
					id='extension_type_update_modal_open'
					onClick={() => setModalOpen(true)}
					startIcon={<MaterialIcon icon='edit' />}
					disabled={disabled}
					variant={'outlined'}
					sx={{ marginBottom: 1 }}
				>
					Update Extension
				</Button>
			</div>
			<Modal
				open={modalOpen}
				onClose={() => {
					setLocalExtension(extension);
					setApiErrors([]);
					setModalOpen(false);
				}}
			>
				<div className={styles.Modal}>
					<Base title='Create Extension Type'>
						{isLoading ? (
							<Spinner />
						) : (
							<>
								<ApiErrors errors={apiErrors} />
								<div className={styles.controlsContainer}>
									<Button
										onClick={e => {
											handleSave();
										}}
										outlined
										startIcon={<MaterialIcon icon='save' />}
										className={styles.editButton}
										id='createExtension_Save'
										disabled={disabled}
									>
										Save
									</Button>
								</div>

								<Section label='Update Extension Type'>
									<div>
										{/* description : string (256) */}
										<div className={styles.detailLabel}>
											<p>
												Description{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localExtension?.description
														?.length
														? localExtension
																.description
																.length
														: 0}
													/{256})
												</span>
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localExtension.description
												)}
												onChange={e => handleChange(e)}
												name='description'
												maxLength={256}
												rows={5}
												id='localExtension_description'
											/>
										</div>

										{/* full : string (256) */}
										<div className={styles.detailLabel}>
											<p>
												Full{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localExtension?.full
														?.length
														? localExtension.full
																.length
														: 0}
													/{256})
												</span>
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
													styles.margin_top_1,
												])}
												type='text'
												value={resolveTextAreaNull(
													localExtension.full
												)}
												onChange={e => handleChange(e)}
												name='full'
												maxLength={256}
												rows={5}
												id='localExtension_full'
											/>
										</div>

										{/* short : string (256) */}
										<div className={styles.detailLabel}>
											<p>
												Short{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localExtension?.short
														?.length
														? localExtension?.short
																?.length
														: 0}
													/{256})
												</span>
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
													styles.margin_top_1,
												])}
												type='text'
												value={resolveTextAreaNull(
													localExtension?.short
												)}
												onChange={e => handleChange(e)}
												name='short'
												maxLength={256}
												rows={5}
												id='localExtension_short'
											/>
										</div>

										{/* order : int  */}
										<div className={styles.detailLabel}>
											<p>Order </p>

											<input
												type='number'
												value={localExtension?.order}
												onChange={e => handleChange(e)}
												name='order'
												min={0}
												id='localExtension_order'
											/>
										</div>
										{/* f_Save_Override_Value : string (255) */}
										<div className={styles.detailLabel}>
											<p>
												Save Override Value{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localExtension
														?.f_Save_Override_Value
														?.length
														? localExtension
																?.f_Save_Override_Value
																?.length
														: 0}
													/{255})
												</span>
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
													styles.margin_top_1,
												])}
												type='text'
												value={resolveTextAreaNull(
													localExtension?.f_Save_Override_Value
												)}
												onChange={e => handleChange(e)}
												name='f_Save_Override_Value'
												maxLength={255}
												rows={5}
												id='Extension_save_override'
											/>
										</div>
									</div>
								</Section>
								<div className={styles.controlsContainer}>
									<Button
										onClick={e => {
											handleSave();
										}}
										outlined
										startIcon={<MaterialIcon icon='save' />}
										className={styles.editButton}
										id='createExtension_Save2'
										disabled={disabled}
									>
										Save
									</Button>
								</div>
							</>
						)}
					</Base>
				</div>
			</Modal>
		</div>
	);
};

export default ExtensionTypeUpdate;
